export const GA_TRACKING_ID = process.env.NEXT_PUBLIC_GA_ID
  ? process.env.NEXT_PUBLIC_GA_ID
  : 'UA-189029385-1'

// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
export const pageview = (url) => {
  window.gtag('config', GA_TRACKING_ID, {
    page_path: url,
  })
}

// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export const event = ({
  action,
  event_category,
  event_label = '',
  value = '',
}) => {
  window.gtag('event', action, {
    event_category,
    event_label,
    value,
  })
}
